// extracted by mini-css-extract-plugin
module.exports = {"kyc":"kyc-withdraw-address-list_kyc_3_Ums"};